import { sql, PostgreSQL } from "@codemirror/lang-sql";
import type { Extension } from "@codemirror/state";

/**
 * Create a CodeMirror SQL extension configured for PostgreSQL with schema data.
 *
 * @param schemaConfig - Schema mapping: table → column names[]
 */
export function postgresSQL(schemaConfig?: Record<string, readonly string[]>): Extension {
  return sql({
    dialect: PostgreSQL,
    upperCaseKeywords: true,
    ...(schemaConfig ? { schema: schemaConfig } : {}),
  });
}

export { catalogToSqlSchema } from "./schema";
export type { SqlSchemaConfig, PostgresCatalog } from "./schema";
